"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupBackend = setupBackend;
exports.MessageBoxTypes = exports.appStore = exports.includeMetadataChanges = void 0;

var _redux = require("redux");

var _index = require("./reducers/index");

var _reduxLogger = _interopRequireDefault(require("redux-logger"));

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _pounderFirebase = require("../pounder-firebase");

var _pounderStores = require("../pounder-stores");

var _pounderDexie = require("../pounder-dexie");

var _pounderThemes = require("../pounder-themes");

var _initialState;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var includeMetadataChanges = {
  includeMetadataChanges: false // Make sure you are calling this first before using the Store.

};
exports.includeMetadataChanges = includeMetadataChanges;

function setupBackend(mode, platform) {
  // Firebase.
  (0, _pounderFirebase.setupFirebase)(mode);

  if (platform === "desktop") {
    exports.includeMetadataChanges = includeMetadataChanges = {
      includeMetadataChanges: true
    };
  } else {
    exports.includeMetadataChanges = includeMetadataChanges = {
      includeMetadataChanges: false
    };
  } // Dexie.


  (0, _pounderDexie.initializeDexie)();
}

var initialState = (_initialState = {
  projects: [],
  members: [],
  memberLookup: {},
  invites: [],
  localProjects: [],
  remoteProjects: [],
  remoteProjectIds: [],
  taskLists: [],
  filteredTaskLists: [],
  localTaskLists: [],
  remoteTaskLists: [],
  tasks: [],
  filteredTasks: [],
  incompletedLocalTasks: [],
  completedLocalTasks: [],
  incompletedRemoteTasks: [],
  completedRemoteTasks: [],
  focusedTaskListId: -1,
  openTaskListWidgetHeaderId: -1,
  openProjectSelectorId: -1,
  selectedProjectLayout: {},
  projectLayoutsMap: {},
  localProjectLayouts: [],
  remoteProjectLayouts: [],
  selectedTask: {
    taskListWidgetId: -1,
    taskId: -1,
    isInputOpen: false
  },
  localMuiThemes: [],
  muiThemes: [_pounderThemes.DefaultTheme],
  selectedProjectId: -1,
  isSelectedProjectRemote: false,
  isATaskMoving: false,
  movingTaskId: -1,
  sourceTaskListId: -1,
  openTaskInfoId: -1,
  openTaskListSettingsMenuId: -1,
  isAwaitingFirebase: false,
  projectSelectorIndicators: [],
  isLockScreenDisplayed: false,
  lastBackupDate: ""
}, _defineProperty(_initialState, "openTaskListSettingsMenuId", -1), _defineProperty(_initialState, "projectsHavePendingWrites", false), _defineProperty(_initialState, "projectLayoutsHavePendingWrites", false), _defineProperty(_initialState, "taskListsHavePendingWrites", false), _defineProperty(_initialState, "tasksHavePendingWrites", false), _defineProperty(_initialState, "isJumpMenuOpen", false), _defineProperty(_initialState, "isShuttingDown", false), _defineProperty(_initialState, "isStartingUp", true), _defineProperty(_initialState, "appSettingsMenuPage", "general"), _defineProperty(_initialState, "databaseInfo", ""), _defineProperty(_initialState, "isDatabasePurging", false), _defineProperty(_initialState, "isDatabaseRestoring", false), _defineProperty(_initialState, "generalConfig", _pounderDexie.generalConfigFallback), _defineProperty(_initialState, "isDexieConfigLoadComplete", false), _defineProperty(_initialState, "isAppSettingsOpen", false), _defineProperty(_initialState, "accountConfig", _pounderFirebase.AccountConfigFallback), _defineProperty(_initialState, "ignoreFullscreenTrigger", false), _defineProperty(_initialState, "cssConfig", _pounderStores.CssConfigStore), _defineProperty(_initialState, "messageBox", {}), _defineProperty(_initialState, "authStatusMessage", ""), _defineProperty(_initialState, "isLoggingIn", false), _defineProperty(_initialState, "isLoggedIn", false), _defineProperty(_initialState, "userEmail", ""), _defineProperty(_initialState, "displayName", ""), _defineProperty(_initialState, "isUpdateSnackbarOpen", false), _defineProperty(_initialState, "isAppDrawerOpen", true), _defineProperty(_initialState, "openShareMenuId", -1), _defineProperty(_initialState, "isShareMenuWaiting", false), _defineProperty(_initialState, "shareMenuMessage", ""), _defineProperty(_initialState, "shareMenuSubMessage", ""), _defineProperty(_initialState, "updatingUserIds", []), _defineProperty(_initialState, "updatingInviteIds", []), _defineProperty(_initialState, "openTaskOptionsId", -1), _defineProperty(_initialState, "showOnlySelfTasks", false), _defineProperty(_initialState, "generalSnackbar", {
  isOpen: false,
  type: 'information',
  message: '',
  selfDismissTime: 0,
  actionOptions: {
    actionButtonText: 'Okay',
    onAction: function onAction() {}
  }
}), _defineProperty(_initialState, "undoSnackbar", {
  isOpen: false,
  text: '',
  onUndo: function onUndo() {}
}), _defineProperty(_initialState, "textInputDialog", {
  isOpen: false,
  text: "",
  label: "",
  title: "",
  onCancel: function onCancel() {},
  onOkay: function onOkay() {}
}), _defineProperty(_initialState, "informationDialog", {
  isOpen: false,
  text: "",
  title: "",
  onOkay: function onOkay() {}
}), _defineProperty(_initialState, "confirmationDialog", {
  isOpen: false,
  text: "",
  title: "",
  affirmativeButtonText: "Okay",
  negativeButtonText: "Cancel",
  onAffirmative: function onAffirmative() {},
  onNegative: function onNegative() {}
}), _defineProperty(_initialState, "itemSelectDialog", {
  isOpen: false,
  title: "",
  text: "",
  items: [],
  affirmativeButtonText: "Okay",
  negativeButtonText: "Cancel",
  onAffirmative: function onAffirmative() {},
  onNegative: function onNegative() {}
}), _defineProperty(_initialState, "quickItemSelectDialog", {
  isOpen: false,
  title: "",
  text: "",
  items: [],
  negativeButtonText: "",
  onSelect: function onSelect() {},
  onNegative: function onNegative() {}
}), _defineProperty(_initialState, "isInRegisterMode", false), _defineProperty(_initialState, "showCompletedTasks", false), _defineProperty(_initialState, "isProjectMenuOpen", false), _defineProperty(_initialState, "isGettingTaskComments", false), _defineProperty(_initialState, "taskComments", []), _defineProperty(_initialState, "pendingTaskCommentIds", []), _defineProperty(_initialState, "isTaskCommentsPaginating", false), _defineProperty(_initialState, "isAllTaskCommentsFetched", false), _defineProperty(_initialState, "openTaskInspectorId", -1), _defineProperty(_initialState, "openTaskInspectorEntity", null), _defineProperty(_initialState, "selectedProjectLayoutType", 'global'), _defineProperty(_initialState, "openChecklistSettingsId", -1), _defineProperty(_initialState, "openChecklistSettingsEntity", null), _defineProperty(_initialState, "isASnackbarOpen", false), _defineProperty(_initialState, "selectedMuiThemeId", 'default'), _defineProperty(_initialState, "enableStates", {
  newProject: false,
  newTaskFab: false,
  newTaskListFab: false,
  projectMenu: false
}), _defineProperty(_initialState, "isOnboarding", false), _defineProperty(_initialState, "onboarderStep", 0), _defineProperty(_initialState, "isInducting", false), _defineProperty(_initialState, "lastUndoAction", null), _defineProperty(_initialState, "canUndo", false), _defineProperty(_initialState, "isAppDrawerCollapsed", false), _initialState);
var appStore = (0, _redux.createStore)(_index.appReducer, initialState, (0, _redux.applyMiddleware)(_reduxThunk["default"].withExtraArgument({
  getFirestore: _pounderFirebase.getFirestore,
  getAuth: _pounderFirebase.getAuth,
  getDexie: _pounderDexie.getDexie,
  getFunctions: _pounderFirebase.getFunctions
})
/* Logger */
)); // Types.

exports.appStore = appStore;
var MessageBoxTypes = {
  STANDARD: "STANDARD",
  OK_ONLY: "OK_ONLY"
};
exports.MessageBoxTypes = MessageBoxTypes;



//////////////////
// WEBPACK FOOTER
// ../handball-libs/libs/pounder-redux/index.js
// module id = 314
// module chunks = 0